import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSinglePage } from "../../reducers/frontEndReducer";
import { getSocialMediaSettings } from "../../reducers/commonReducer";

const Footer = ({ onLoginClick }) => {
  const dispatch = useDispatch();
  const width = useRef(window.innerWidth);
  useEffect(() => {
    dispatch(getSocialMediaSettings());
  }, []);
  const { getPagesList } = useSelector((state) => state.frontEndReducer);
  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );
  return (
    <footer className="bg-light py-5">
      <div className="container d-flex flex-column flex-md-row justify-content-between">

        <div className="mb-4 mb-md-0">
          <img src="https://d17x24txz4ixmz.cloudfront.net/images/logo4x.webp" alt="logo" height="40" className="mb-2" />
          <p className="mb-1">{getSocialMediaSettingsData?.address}</p>

          <p className="mb-1"> {getSocialMediaSettingsData?.city},{getSocialMediaSettingsData?.state},{getSocialMediaSettingsData?.zip}</p>
          <p className="mb-2">
            <a href={getSocialMediaSettingsData?.phone} className="text-dark text-decoration-none">
              <i className="bi bi-telephone-fill me-2"></i>{getSocialMediaSettingsData?.phone}

            </a>
          </p>
          <div className="d-flex gap-3">

            <a href={getSocialMediaSettingsData?.instagram} target="_blank" rel="noreferrer">
              <i className="bi bi-instagram fs-5 text-dark"></i>
            </a>
            <a href={getSocialMediaSettingsData?.linkdin} target="_blank" rel="noreferrer">

              <i className="bi bi-linkedin fs-5 text-dark"></i>
            </a>
            <a href={getSocialMediaSettingsData?.twitter} target="_blank" rel="noreferrer">
              <i className="bi bi-twitter fs-5 text-dark"></i>
            </a>
          </div>
        </div>

        {/* Column 2: Products */}
        <div className="mb-4 mb-md-0">
          <h6 className="fw-bold">Products</h6>
          <ul className="list-unstyled">
            <li><Link to="/itr" className="text-dark text-decoration-none">ITR filing</Link></li>
            <li><Link to="/gst" className="text-dark text-decoration-none">GST registration</Link></li>
            <li><Link to="/funds" className="text-dark text-decoration-none">Tax savings funds</Link></li>
          </ul>
        </div>

        {/* Column 3: taxNwealth */}
        <div className="mb-4 mb-md-0">
          <h6 className="fw-bold">taxNwealth</h6>
          <ul className="list-unstyled">
            <li><Link to="/blog" className="text-dark text-decoration-none">Blog</Link></li>
            {/* <li className="text-dark text-decoration-none">
              <LoginPop title="Client login" />
            </li> */}

          </ul>
        </div>




        {/* Column 4: Quicklinks */}
        <div>
          <h6 className="fw-bold">Quicklinks</h6>
          <ul className="list-unstyled">
            {!!getPagesList &&
              getPagesList.map((data, index) => {
                return (
                  <li key={index}>
                    <Link
                      className="text-dark text-decoration-none"
                      onClick={() => {
                        dispatch(
                          getSinglePage({ slug: data?.slug })
                        );
                      }}
                      to={`/${data?.slug}`}
                    >
                      {data?.name}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
